/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

export default ({
  id: 'mobile',
  name: 'Mobile',
  owner: 'grossen@adobe.com',
  allowUserWorkspaces: true,
  allowOrgWorkspaces: true,
  workspaces: [
    {
      id: 'mobile',
      name: 'Mobile',
      enabledViewPlugins: [
        'aep-mobile-config-viewer',
        'aep-mobile-sharedstate',
        'aep-mobile-versions',
        'analytics',
        'event-list',
        'x-edge'
      ],
      validationPlugins: {
        'adobe-analytics-configuration': { level: 'error' },
        'adobe-analytics-post-processed': { level: 'error' },
        'adobe-analytics-response-events': { level: 'error' },
        'aep-edge-configured': { level: 'error' },
        'edge-analytics-mapping': { level: 'error' },
        'edge-analytics-mobile-track-hit': { level: 'error' },
        'edge-analytics-streaming-validation': { level: 'error' },
        'edge-streaming-validation': { level: 'error' }
      }
    }
  ]
});
